import { formatMUR } from '../lib/money';
import { cn } from '../lib/cn';

export function Money({
  value,
  className,
  muted,
}: {
  value: number | string | null | undefined;
  className?: string;
  muted?: boolean;
}): JSX.Element {
  return (
    <span className={cn('kc-mono kc-tnum', muted && 'text-ink-3', className)}>
      {formatMUR(value)}
    </span>
  );
}
